import React from 'react';
import { Modal, Typography } from 'antd';
import CloseIcon from '@mui/icons-material/Close';

/**
 * A reusable modal component for stepper interfaces
 * 
 * @param {Object} props - Component properties
 * @param {string} props.title - Modal title
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onCancel - Function called when the modal is closed
 * @param {React.ReactNode} props.children - Modal content (typically a stepper component)
 * @param {boolean} props.maskClosable - Whether clicking the mask closes the modal (default: false)
 * @param {boolean} props.destroyOnHidden - Whether to destroy the modal's children when it's hidden (default: true)
 */
const StepperModal = ({
    title,
    visible,
    onCancel,
    children,
    maskClosable = false,
    destroyOnHidden = true
}) => {
    return (
        <Modal
            title={
                <Typography.Title level={4} style={{ marginBottom: '1rem' }}>
                    {title}
                </Typography.Title>
            }
            open={visible}
            onCancel={onCancel}
            width="85vw"
            centered
            maskClosable={maskClosable}
            footer={null}
            destroyOnHidden={destroyOnHidden}
            closeIcon={
                <div
                    className="modal-close-button"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                        // Ensure the clickable area is well-defined
                        padding: '8px',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    <CloseIcon
                        style={{
                            fontSize: '24px',
                            color: '#666',
                            margin: 0,
                            // Ensure the icon doesn't interfere with the click
                            pointerEvents: 'none'
                        }}
                    />
                </div>
            }
        >
            {children}
        </Modal>
    );
};

export default StepperModal; 